// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'BrandonText-Bold';
  src: url('/fonts/BrandonText-Bold.otf') format('opentype');
}

@font-face {
  font-family: 'BrandonText-Black';
  src: url('/fonts/BrandonText-Black.otf') format('opentype');
}

@font-face {
  font-family: 'BrandonText-Medium';
  src: url('/fonts/BrandonText-Medium.otf') format('opentype');
}

@font-face {
  font-family: 'BrandonText-Regular';
  src: url('/fonts/BrandonText-Regular.otf') format('opentype');
}

@font-face {
  font-family: 'ProximaNova-Bold';
  src: url('/fonts/ProximaNova-Bold.otf') format('opentype');
}

@font-face {
  font-family: 'ProximaNova-Semibold';
  src: url('/fonts/ProximaNova-Semibold.otf') format('opentype');
}

@font-face {
  font-family: 'ProximaNova-Light';
  src: url('/fonts/ProximaNova-Light.otf') format('opentype');
}

@font-face {
  font-family: 'ProximaNova-Regular';
  src: url('/fonts/ProximaNova-Regular.otf') format('opentype');
}

@keyframes icon-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.icon-spin {
  -webkit-animation: icon-spin 2s infinite linear;
  animation: icon-spin 2s infinite linear;
}

html {
  font-size: 16px;
}

html,
body {
  /* position: fixed; */
  height: 100%;
  width: 100%;
}

#modal-root,
#error-modal {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: stretch;
}

input.visit-input {
  font-family: ProximaNova-Semibold, Lato, sans-serif;
  font-size: 1.1rem;
  border: none;
}

input.visit-input:focus {
  outline: none;
}

body {
  font-family: ProximaNova-Semibold;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

#root {
  display: flex;
  overflow: hidden;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  flex-direction: column;
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
}

.fade-enter {
  opacity: 0;
}

.fade-enter.fade-enter-active {
  transition: 300ms linear;
  opacity: 1 !important;
}

.fade-enter-done {
  opacity: 1 !important;
}

.fade-exit {
  opacity: 1 !important;
}

.fade-exit.fade-exit-active {
  opacity: 0;
  transition: 3000ms linear;
}

.fade-in-enter,
.fade-in-appear {
  transform: translateY(2rem);
  opacity: 0;
}

.fade-in-enter.fade-in-enter-active,
.fade-in-appear.fade-in-appear-active {
  transition: 200ms linear;
  transform: none;
  opacity: 1;
}

.slide-next-enter {
  transform: translateX(100%);
}

.slide-next-enter.slide-next-enter-active {
  transition: 200ms linear;
  transform: unset;
}

.slide-next-exit {
  transform: translateY(-100%);
}

.slide-next-exit.slide-next-exit-active {
  transition: 200ms linear;
  transform: translate(100%, -100%);
}

.slide-previous-enter {
  transform: scale(0.9);
}

.slide-previous-enter.slide-previous-enter-active {
  transition: 200ms linear;
  transform: unset;
}

.slide-previous-exit {
  transform: translateX(-100%);
}

.slide-previous-exit.slide-previous-exit-active {
  transition: 200ms linear;
  transform: translateX(-100%) scale(0.6);
}

.fly-in-enter,
.fly-in-appear {
  transform: translateY(100%);
}

.fly-in-enter.fly-in-enter-active,
.fly-in-appear.fly-in-appear-active {
  transition: 200ms linear;
  transform: none;
}

.fly-in-exit {
  transform: none;
}

.fly-in-exit.fly-in-exit-active {
  transition: 200ms linear;
  transform: translateY(100%);
}

.slide-in-enter,
.slide-in-appear {
  transform: translateX(100%);
}

.slide-in-enter.slide-in-enter-active,
.slide-in-appear.slide-in-appear-active {
  transition: 200ms linear;
  transform: none;
}

.slide-in-exit {
  transform: none;
}

.slide-in-exit.slide-in-exit-active {
  transition: 200ms linear;
  transform: translateX(100%);
}

/* .expand-hide-enter.expand-hide-enter-active {
  padding: 0 !important;
  height: 0;
  transition: 200ms linear;
}

.expand-hide-enter-done {
  padding: 0 !important;
  height: 0;
}

.expand-enter.expand-enter-active {
  background: white;
  transition: 200ms linear;
  margin-top: 0;
  transform: translateY(-100%);
}

.expand-enter-done {
  background: white;
  margin-top: 0;
  transform: translateY(-100%);
} */

.expand-enter,
.expand-appear {
  transform: scaleY(0.2);
  transform-origin: top;
}

.expand-enter.expand-enter-active,
.expand-appear.expand-appear-active {
  transform-origin: top;
  transform: scaleY(1);
  transition: all 150ms linear 0s;
}

.expand-exit {
  transform-origin: top;
  transform: scaleY(1);
  transform: none;
}

.expand-exit.expand-exit-active {
  transform-origin: top;
  transform: scaleY(0);
  transition: all 150ms linear 0s;
}

.expand-done-exit {
  transform-origin: top;
  transform: scaleY(0);
  transform: none;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #7f7f7f;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #7f7f7f;
  opacity: 0.5;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #7f7f7f;
  opacity: 0.5;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #7f7f7f;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #7f7f7f;
}

::placeholder {
  /* Most modern browsers support this now. */
  color: rgba(127, 127, 127, 0.5);
  /* opacity:  0.5; */
}

.placeIdModal {
  width: 900px !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,iCAAiC;EACjC,4DAA4D;AAC9D;;AAEA;EACE,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,8DAA8D;AAChE;;AAEA;EACE,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Lato:400,700');\n\n@font-face {\n  font-family: 'BrandonText-Bold';\n  src: url('/fonts/BrandonText-Bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'BrandonText-Black';\n  src: url('/fonts/BrandonText-Black.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'BrandonText-Medium';\n  src: url('/fonts/BrandonText-Medium.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'BrandonText-Regular';\n  src: url('/fonts/BrandonText-Regular.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ProximaNova-Bold';\n  src: url('/fonts/ProximaNova-Bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ProximaNova-Semibold';\n  src: url('/fonts/ProximaNova-Semibold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ProximaNova-Light';\n  src: url('/fonts/ProximaNova-Light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ProximaNova-Regular';\n  src: url('/fonts/ProximaNova-Regular.otf') format('opentype');\n}\n\n@keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n.icon-spin {\n  -webkit-animation: icon-spin 2s infinite linear;\n  animation: icon-spin 2s infinite linear;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nhtml,\nbody {\n  /* position: fixed; */\n  height: 100%;\n  width: 100%;\n}\n\n#modal-root,\n#error-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  z-index: 999;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n.modal-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: stretch;\n}\n\ninput.visit-input {\n  font-family: ProximaNova-Semibold, Lato, sans-serif;\n  font-size: 1.1rem;\n  border: none;\n}\n\ninput.visit-input:focus {\n  outline: none;\n}\n\nbody {\n  font-family: ProximaNova-Semibold;\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n#root {\n  display: flex;\n  overflow: hidden;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n  flex-direction: column;\n  max-width: 100%;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.fade-enter {\n  opacity: 0;\n}\n\n.fade-enter.fade-enter-active {\n  transition: 300ms linear;\n  opacity: 1 !important;\n}\n\n.fade-enter-done {\n  opacity: 1 !important;\n}\n\n.fade-exit {\n  opacity: 1 !important;\n}\n\n.fade-exit.fade-exit-active {\n  opacity: 0;\n  transition: 3000ms linear;\n}\n\n.fade-in-enter,\n.fade-in-appear {\n  transform: translateY(2rem);\n  opacity: 0;\n}\n\n.fade-in-enter.fade-in-enter-active,\n.fade-in-appear.fade-in-appear-active {\n  transition: 200ms linear;\n  transform: none;\n  opacity: 1;\n}\n\n.slide-next-enter {\n  transform: translateX(100%);\n}\n\n.slide-next-enter.slide-next-enter-active {\n  transition: 200ms linear;\n  transform: unset;\n}\n\n.slide-next-exit {\n  transform: translateY(-100%);\n}\n\n.slide-next-exit.slide-next-exit-active {\n  transition: 200ms linear;\n  transform: translate(100%, -100%);\n}\n\n.slide-previous-enter {\n  transform: scale(0.9);\n}\n\n.slide-previous-enter.slide-previous-enter-active {\n  transition: 200ms linear;\n  transform: unset;\n}\n\n.slide-previous-exit {\n  transform: translateX(-100%);\n}\n\n.slide-previous-exit.slide-previous-exit-active {\n  transition: 200ms linear;\n  transform: translateX(-100%) scale(0.6);\n}\n\n.fly-in-enter,\n.fly-in-appear {\n  transform: translateY(100%);\n}\n\n.fly-in-enter.fly-in-enter-active,\n.fly-in-appear.fly-in-appear-active {\n  transition: 200ms linear;\n  transform: none;\n}\n\n.fly-in-exit {\n  transform: none;\n}\n\n.fly-in-exit.fly-in-exit-active {\n  transition: 200ms linear;\n  transform: translateY(100%);\n}\n\n.slide-in-enter,\n.slide-in-appear {\n  transform: translateX(100%);\n}\n\n.slide-in-enter.slide-in-enter-active,\n.slide-in-appear.slide-in-appear-active {\n  transition: 200ms linear;\n  transform: none;\n}\n\n.slide-in-exit {\n  transform: none;\n}\n\n.slide-in-exit.slide-in-exit-active {\n  transition: 200ms linear;\n  transform: translateX(100%);\n}\n\n/* .expand-hide-enter.expand-hide-enter-active {\n  padding: 0 !important;\n  height: 0;\n  transition: 200ms linear;\n}\n\n.expand-hide-enter-done {\n  padding: 0 !important;\n  height: 0;\n}\n\n.expand-enter.expand-enter-active {\n  background: white;\n  transition: 200ms linear;\n  margin-top: 0;\n  transform: translateY(-100%);\n}\n\n.expand-enter-done {\n  background: white;\n  margin-top: 0;\n  transform: translateY(-100%);\n} */\n\n.expand-enter,\n.expand-appear {\n  transform: scaleY(0.2);\n  transform-origin: top;\n}\n\n.expand-enter.expand-enter-active,\n.expand-appear.expand-appear-active {\n  transform-origin: top;\n  transform: scaleY(1);\n  transition: all 150ms linear 0s;\n}\n\n.expand-exit {\n  transform-origin: top;\n  transform: scaleY(1);\n  transform: none;\n}\n\n.expand-exit.expand-exit-active {\n  transform-origin: top;\n  transform: scaleY(0);\n  transition: all 150ms linear 0s;\n}\n\n.expand-done-exit {\n  transform-origin: top;\n  transform: scaleY(0);\n  transform: none;\n}\n\n::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #7f7f7f;\n}\n\n:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #7f7f7f;\n  opacity: 0.5;\n}\n\n::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #7f7f7f;\n  opacity: 0.5;\n}\n\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #7f7f7f;\n}\n\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #7f7f7f;\n}\n\n::placeholder {\n  /* Most modern browsers support this now. */\n  color: rgba(127, 127, 127, 0.5);\n  /* opacity:  0.5; */\n}\n\n.placeIdModal {\n  width: 900px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
